module.exports = __webpack_public_path__ + "img/menu_payment.1ccce522.png";